import PatientsTable from '~/components/maud/patients/list';

const Patients = () => <PatientsTable />;

export default Patients;
